import { ProductLogoMediumIDAndAccess } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_staff/id-managements/_layout")({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation();
  useDocumentTitle(t("pages.idManagements.list.pageTitle"));

  const tabs = [
    {
      to: "/id-managements/overview",
      children: t("common.list.overview"),
      activeOptions: { exact: true },
    },
    {
      to: "/id-managements",
      children: t("common.list.idLists"),
      activeOptions: { exact: true, includeSearch: true },
    },
    {
      to: "/id-managements/group-id",
      children: t("common.list.groupId"),
      activeOptions: { exact: true, includeSearch: false },
    },
    {
      to: "/id-managements/alerts",
      children: t("common.list.alerts"),
      activeOptions: { exact: true, includeSearch: false },
    },
    {
      to: "/id-managements/rule-and-policy",
      children: t("common.list.ruleAndPolicy"),
      activeOptions: { exact: true, includeSearch: false },
    },
    {
      to: "/id-managements/operation-activity",
      children: t("common.list.operationActivity"),
    },
    {
      to: "/id-managements/settings",
      children: t("common.list.settings"),
      activeOptions: { exact: true, includeSearch: false },
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={ProductLogoMediumIDAndAccess}
        name={t("pages.idManagements.list.pageTitle")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
